import { ListItemIcon as MuiListItemIcon, styled } from '@mui/material';
import { colors } from 'components/Colors';

const ListItemIcon = styled(MuiListItemIcon)`
  && {
    min-width: auto;
    margin-right: 5px;
    color: ${colors.common.text.value};
    font-size: 16px;
  }
`;

export default ListItemIcon;
